// @flow
import React from 'react';
import Chip from 'material-ui/Chip';
import { red900, green300, orange500 } from 'material-ui/styles/colors';

const styles = {
  chip: {
    margin: 8,
  },
};

type Props = {
  status: string,
};

const JobOfferStatus = ({ status }: Props) => {
  switch (status) {
    case 'JobOfferStatus.Open':
      return (
        <Chip style={styles.chip} backgroundColor={green300}>
          Open
        </Chip>
      );
    case 'JobOfferStatus.Accepted':
      return (
        <Chip style={styles.chip} backgroundColor={green300}>
          Accepted
        </Chip>
      );
    case 'JobOfferStatus.Completed':
      return (
        <Chip style={styles.chip} backgroundColor={green300}>
          Completed
        </Chip>
      );
    case 'JobOfferStatus.Cancelled':
      return (
        <Chip style={styles.chip} backgroundColor={red900}>
          Cancelled
        </Chip>
      );
    case 'JobOfferStatus.Declined':
      return (
        <Chip style={styles.chip} backgroundColor={red900}>
          Declined
        </Chip>
      );
    case 'JobOfferStatus.Lost':
      return (
        <Chip style={styles.chip} backgroundColor={red900}>
          Lost
        </Chip>
      );
    case 'JobOfferStatus.Expired':
      return (
        <Chip style={styles.chip} backgroundColor={orange500}>
          Expired
        </Chip>
      );
    default:
      return null;
  }
};

export default JobOfferStatus;



// WEBPACK FOOTER //
// ./src/modules/job/components/JobOfferStatus.js